export default __webpack_public_path__ + "static/media/tel-webconfirm.91c2dfc6.svg";